import { Button, Form, Modal, message } from "antd";
import { useState } from "react";
import DataTable from "../../../../../components/Tables/DataTable";
import FormModal from "./FormModal";
import dayjs from "dayjs";
import {
  useAddBoxMutation,
  useDeleteBoxMutation,
  useEditBoxMutation,
  useGetBoxsQuery,
} from "../../../../../redux/Service/BoxesApi";
import { useGetCurrenciesQuery } from "../../../../../redux/Service/currenciesApi";
import { useGetAccountsQuery } from "../../../../../redux/Service/Accounts";

function Boxes() {
  const [form] = Form.useForm();
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isEditing, setIsEditing] = useState(false);

  const { data: boxesData, isLoading: isBoxesLoading } =
    useGetBoxsQuery(undefined);
  const boxes = boxesData?.ResponseObject ?? [];

  const { data: currenciesData } = useGetCurrenciesQuery(undefined);
  const currencies = currenciesData?.ResponseObject ?? [];

  const { data: accountsData } = useGetAccountsQuery(undefined);
  const accounts = accountsData?.ResponseObject ?? [];

  const [deleteBox, { isLoading: isDeleting }] = useDeleteBoxMutation();
  const [addBox, { isLoading: isAdding }] = useAddBoxMutation();
  const [updateBox, { isLoading: isUpdating }] = useEditBoxMutation();

  const handleDeletClick = (record) => {
    Modal.confirm({
      title: "تأكيد الحذف",
      content: `هل أنت متأكد أنك تريد حذف الخزينة "${record.BoxName}"؟`,
      okText: "حذف",
      okType: "danger",
      cancelText: "إلغاء",
      onOk: async () => {
        try {
          const response = await deleteBox(record.BoxID).unwrap();
          if (response?.ResponseObject === true) {
            message.success("تم حذف الخزينة بنجاح");
          } else {
            message.error("حدث خطأ أثناء الحذف");
          }
        } catch {
          message.error("فشل الاتصال بالخادم");
        }
      },
    });
  };

  const columns = [
    { title: "اسم الخزينة", dataIndex: "BoxName", key: "BoxName" },
    {
      title: "العملة",
      dataIndex: "CurrID",
      key: "CurrID",
      render: (text) => {
        const currency = currencies.find((cur) => cur.CurrID === text);
        return currency ? currency.CurrName : text;
      },
    },
    {
      title: "الحساب",
      dataIndex: "AccId",
      key: "AccId",
      render: (text) => {
        const account = accounts.find((acc) => acc.AccID === text);
        return account ? account.AccName : text;
      },
    },
  ];

  const handleOk = async (values) => {
    const body = {
      ...values,
      FirstBalDate: values.FirstBalDate?.format("YYYY-MM-DDTHH:mm:ss"),
    };

    try {
      const response = isEditing
        ? await updateBox(body).unwrap()
        : await addBox(body).unwrap();

      if (response?.ResponseObject === true) {
        message.success(
          isEditing ? "تم تعديل الخزينة بنجاح" : "تمت إضافة الخزينة بنجاح"
        );
        setIsModalOpen(false);
        resetModal();
      } else {
        message.error("حدث خطأ أثناء العملية");
      }
    } catch {
      message.error("فشل الاتصال بالخادم");
    }
  };

  const resetModal = () => {
    form.resetFields();
    setIsEditing(false);
  };

  const handleCancel = () => {
    setIsModalOpen(false);
    resetModal();
  };

  const handleEditClick = (record) => {
    setIsEditing(true);
    setIsModalOpen(true);
    const recordData = {
      ...record,
      FirstBalDate: record.FirstBalDate ? dayjs(record.FirstBalDate) : null,
    };
    setTimeout(() => {
      form.setFieldsValue(recordData);
    }, 0);
  };

  return (
    <div className="flex flex-wrap gap-4 relative">
      <div className="grid justify-start my-2">
        <Button
          type="primary"
          style={{ width: "10rem" }}
          onClick={() => setIsModalOpen(true)}
        >
          إضافة خزينة
        </Button>
      </div>

      <FormModal
        form={form}
        isEditing={isEditing}
        isModalOpen={isModalOpen}
        handleOk={handleOk}
        handleCancel={handleCancel}
        loading={isAdding || isUpdating}
        currencies={currencies}
        accounts={accounts}
      />

      <DataTable
        columns={columns}
        data={boxes}
        handleEditClick={handleEditClick}
        handleDeletClick={handleDeletClick}
        isLoading={isBoxesLoading || isDeleting}
      />
    </div>
  );
}

export default Boxes;
